import { useState, useEffect } from 'react';
import { execSeatableSql } from './seatable.js';
import * as consts from '../consts.js';
import SectionHeader from './sectionheader.js';
import AllMarkdown from './allmarkdown.js';

function Segments(props) {
    const [data, setData] = useState(null);

    useEffect(() => {
        async function fetchData() {
            const sql = `SELECT \`Desc\`, \`SegmentSubSection\`, \`fnMediaLink\` FROM \`Capability Segment\` WHERE \`Capability\` = '${props.capability}'`;
            setData(null);

            try {
                const rows = await execSeatableSql(sql);
                setData(rows && rows.results);
            } catch (err) {
                // setError(err);
            }
        }
        fetchData();
    }, [props.capability]);

    return <>
        {(data && (data.length > 0)) ?
        <div>
            <div id="Segments" className='nav-margin'>
                <SectionHeader capability={props.capability} section="Segments"/>
            </div>
            <div className="segments pb-5 border-bottom border-secondary">
                {data && data.map((row, index) => { return (
                    <Segment key={index} row={row} index={index} />
                )})}
            </div>
        </div>
        : ''}
    </>
}

function Segment(props) {
    const [showExpand, setShowExpand] = useState(true);
    const [toggleExpand, setToggleExpand] = useState(false);

    const handleBtnClick = () => {
        setToggleExpand(!toggleExpand)
    } 

    const getShowExpand = (data) => {
        setShowExpand(toggleExpand || data)
    }

    return (
        <div key={toggleExpand} className="segment flex-lg-row flex-column">
            <div className="p-3 d-flex flex-row segment-title justify-content-center">
                <h4 className="my-auto me-3">{props.row.Desc}</h4>
                <div className="ms-auto my-3" style={{width: "30px", height: "10px", backgroundColor: `${consts.colorPalette[props.index%9]}`}}></div>
            </div>
            {props.row["fnMediaLink"] ? (
            <div className="img-fluid" style={{backgroundImage: `url(${props.row["fnMediaLink"]})`, backgroundSize: "cover", minHeight: "200px"}} />
            ) : ''}
            {props.row.SegmentSubSection ? (<>
            <div className={`p-3 d-flex flex-row card-content ${toggleExpand ? 'card-expanded' : ''}`}>
                <AllMarkdown getShowExpand={getShowExpand}>{props.row.SegmentSubSection && props.row.SegmentSubSection}</AllMarkdown>
            </div>
            <div className={`pe-3 pb-2 ${showExpand ? 'd-flex' : 'd-none'} flex-row justify-content-end align-items-end card-btn`} onClick={handleBtnClick} >
                <i className={`bi bi-arrow-${toggleExpand ? 'up' : 'down'}-circle`}></i>
            </div>
            </>) : ''}
        </div>
    )
}

export default Segments;